export class BaseError extends Error {
  constructor(message: string) {
    super(message)
    this.message = message
  }
}
export const localUserKey = 'spacen_user_token'
